/** @flow */
import { takeLatest, put, call } from "redux-saga/effects";
import http from "@http";
import {
  GetReportingFocusListsManagerDefaultReports,
  GetReportingFocusListsManagerMyReports,
} from "@modules/reporting/constants/actions";
import actionCreator from "@modules/reporting/actionCreator";
import type { DefaultReports } from "@modules/reporting/reducer/focus-lists/manager/types";

type ReportDataResponse = DefaultReports;

function* onGetReportingFocusListsManagerDefaultReports(
  action,
): Generator<*, void, { data: ReportDataResponse }> {
  try {
    const { clientId } = action.payload;

    const response = yield call(
      http.get,
      `/api/v1/focus-lists/client/${clientId}/focus-lists/manager/default-reports`,
    );
    yield put(actionCreator.GetReportingFocusListsManagerDefaultReportsSuccess(response.data));
  } catch (e) {
    yield put(
      actionCreator.GetReportingFocusListsManagerDefaultReportsError({
        error: e.message,
      }),
    );
  }
}

function* onGetReportingFocusListsManagerMyReports(
  action,
): Generator<*, void, { data: ReportDataResponse }> {
  try {
    const { clientId } = action.payload;

    const response = yield call(
      http.get,
      `/api/v1/focus-lists/client/${clientId}/focus-lists/manager/my-saved-reports`,
    );
    yield put(actionCreator.GetReportingFocusListsManagerMyReportsSuccess(response.data));
    yield put(actionCreator.ReSetFocusListsManagerReportToSave());
  } catch (e) {
    yield put(
      actionCreator.GetReportingFocusListsManagerMyReportsError({
        error: e.message,
      }),
    );
  }
}

export default function* reportSaga(): Generator<*, void, void> {
  yield takeLatest(
    GetReportingFocusListsManagerMyReports,
    onGetReportingFocusListsManagerMyReports,
  );
  yield takeLatest(
    GetReportingFocusListsManagerDefaultReports,
    onGetReportingFocusListsManagerDefaultReports,
  );
}
